export default "__VITE_ASSET__BDy3nRK___"